module.exports = __webpack_public_path__ + "img/announcement.ef6538c8.svg";